import { useEffect, useRef, useState } from "react"
import 'mapbox-gl/dist/mapbox-gl.css'
import mapboxgl from '!mapbox-gl' // eslint-disable-line import/no-webpack-loader-syntax

mapboxgl.accessToken = 'pk.eyJ1Ijoid2lsZHNlbnNlIiwiYSI6ImNsb3p0aGc4MjAxYjQyaWxnZ3BqOHF4M3oifQ.gGCvb8JUxunQHPefE_xsTQ'

export const Map = ({shape, coord, zoom = 16}) => {
  const mapContainer = useRef(null)
  const map = useRef(null)
  const [lng, setLng] = useState(coord.lon)
  const [lat, setLat] = useState(coord.lat)
  const [zoomLvl, setZoomLvl] = useState(zoom)

  useEffect(() => {
    if (map.current) return; // initialize map only once
    const m = new mapboxgl.Map({
      container: mapContainer.current,
      //style: 'mapbox://styles/mapbox/streets-v12',
      style: 'mapbox://styles/mapbox/satellite-v9',
      center: [lng, lat],
      zoom: zoomLvl
    })

    m.on('load', () => {
      m.addSource('shape', {type: 'geojson', data: shape})
      m.addLayer({
        'id': 'shape',
        'type': 'fill',
        'source': 'shape',
        'layout': {},
        'paint': {
          'fill-color': '#F49D4D',
          'fill-opacity': 0.3
        }
      })
      m.addLayer({
        'id': 'shape-outline',
        'type': 'line',
        'source': 'shape',
        'layout': {},
        'paint': {
          'line-color': '#fff',
          'line-width': 1
        }
        });

    })

    map.current = m
  })

  return (
    <div ref={mapContainer} className="map-container" style={{height: '100%', borderRadius: 8}}/>
  )
}